function AdminSchoolsZonesController($scope, $state) {}
AdminSchoolsZonesController.$inject = ["$scope", "$state"];
export default AdminSchoolsZonesController;
